module.exports = __webpack_public_path__ + "img/fondo1a.e6e11ce2.jpg";